import React from 'react';
import { Link } from 'react-router-dom';
import { getImagePath } from '../config/siteConfig';
import '../styles/PackageCard.css';

const PackageCard = ({ package: pkg }) => {
  return (
    <div className="package-card-glass">
      <div className="package-image-glass">
        <img
          src={getImagePath(pkg.image)}
          alt={pkg.title}
          loading="lazy"
        />
        <div className="package-overlay-glass"></div>
        <div className="package-badge-glass">{pkg.category}</div>
        {pkg.featured && <div className="featured-badge-glass">⭐ Featured</div>}
      </div>
      <div className="package-content-glass">
        <h3 className="package-title-glass">{pkg.title}</h3>
        
        <div className="package-meta-glass">
          <span className="package-duration-glass">
            <i className="fas fa-clock"></i> {pkg.duration}
          </span>
          {pkg.rating && (
            <span className="package-rating-small">
              <i className="fas fa-star"></i> {pkg.rating}
            </span>
          )}
        </div>
        
        <p className="package-description-glass">{pkg.description}</p>
        
        {pkg.highlights && (
          <div className="package-highlights-glass">
            {pkg.highlights.slice(0, 3).map((highlight, index) => (
              <span key={index} className="highlight-badge-glass">
                {highlight}
              </span>
            ))}
          </div>
        )}
        
        <Link to={pkg.link} className="btn-view-glass">
          View Details
          <i className="fas fa-arrow-right"></i>
        </Link>
      </div>
    </div>
  );
};

export default PackageCard;
